/**
 * 2022-02-12
 * origin: https://app.zeplin.io/project/614bed834869303d4a4096e4/screen/61dc3caba7a65728a5d0f923
 * icon卖点组件之No.2
 */

import css from '../First/index.module.scss';
import { TextModule, TextIconCell } from '@/components/ProductDetailComponents';
import EFBlueTick from '@/components/UI/svg/Icons/EFBlueTick';

const defaultStyle = {
    backColor: 'transparent',
    height: 'auto',
    guideStyle: {
        fontClass: 'font-family-semibold',
        fontWeight: 500,
        color: '#2673ff',
        fontSize: '32px',
        lineHeight: '40px',
        margin: '0 0 10px 0',
    },
    titleStyle: {
        type: 'ls',
        fontFamily: 'var(--font-family-ExtraBold)',
        margin: '0 0 40px 0',
    },
    descStyle: {
        type: 'sl',
        fontClass: 'font-family-semibold',
        color: '#03060b',
        margin: '0 0 120px 0',
    },
    textIconStyle: {
        wrapperPadding: '0 0 28px 0',
        desColor: '#919191',
        iconMargin: '0 0 30px',
        titleLineHeight: '36px',
    },
};

const defaultData = {
    guide: { text: 'Interior / Exterior Design' },
    title: { text: 'Power pretty much anything' },
    desc: {
        text: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? ',
    },
    items: [
        {
            icon: <EFBlueTick />,
            title: 'Wired control',
            des: 'DELTA Pro is the first portable power station with a remote control. Mount it up, wire it up and control from a distance. ',
            directUrl: '/',
        },
        {
            icon: <EFBlueTick />,
            title: 'Wireless control',
            des: 'Use the remote control via bluetooth to control without wires. Or, link the EcoFlow app and control from anywhere with a wi-fi connection. ',
            directUrl: '/',
        },
        {
            icon: <EFBlueTick />,
            title: 'On-unit control',
            des: 'DELTA Pro’s tactile buttons on the front of the unit pair with a bright LCD screen to give you all the control and information you need. ',
            directUrl: '/',
        },
    ],
};
/**
 *
 * @param data {
 *  guide: 参考TextModule组件data参数,
 *  title: 参考TextModule组件data参数,
 *  desc: 参考TextModule组件data参数,
 *  items: 参考TextIconCell组件data参数,
 * }
 * @param defaultStyle{
 *  backColor: 组件整体风格背景色 string,
 *  guideStyle: 参考TextModule组件cssStyle参数,
 *  titleStyle: 参考TextModule组件cssStyle参数,
 *  descStyle: 参考TextModule组件cssStyle参数,
 *  textIconStyle: 参考TextIconCell组件cssStyle参数,
 * }
 */

export default function Second({ cssStyle = defaultStyle, data = defaultData }: any) {
    const { guide, title, desc, items } = {
        guide: { ...defaultData.guide, ...data.guide },
        title: { ...defaultData.title, ...data.title },
        desc: { ...defaultData.desc, ...data.desc },
        items: data.items,
    };
    cssStyle.guideStyle = {
        ...defaultStyle.guideStyle,
        ...{ backColor: cssStyle.backColor },
        ...cssStyle.guideStyle,
    };
    cssStyle.titleStyle = {
        ...defaultStyle.titleStyle,
        ...{ backColor: cssStyle.backColor },
        ...cssStyle.titleStyle,
    };
    cssStyle.descStyle = {
        ...defaultStyle.descStyle,
        ...{ backColor: cssStyle.backColor },
        ...cssStyle.descStyle,
    };
    cssStyle.textIconStyle = {
        ...defaultStyle.textIconStyle,
        ...{ wrapperBackColor: cssStyle.backColor },
        ...cssStyle.textIconStyle,
    };
    const { backColor, height, guideStyle, titleStyle, descStyle, textIconStyle } = cssStyle;

    return (
        <div className={`${css.sellPointsModule} sellPointsModuleFirst`} style={{ background: backColor, height: height }}>
            <div className="container">
                <TextModule cssStyle={guideStyle} data={guide} />
                <TextModule cssStyle={titleStyle} data={title} />
                <TextModule cssStyle={descStyle} data={desc} />
                <ul className="sellLists">
                    {items.map((item: any, k: number) => (
                        <li
                            className="list"
                            key={k}
                            style={{
                                width: items.length === 2 ? '480px' : '336px',
                                marginLeft: k === 0 ? '0' : items.length === 2 ? '120px' : '56px',
                            }}
                        >
                            <TextIconCell cssStyle={textIconStyle} data={item} />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
